import React from "react"
import { CalendarEventDataFragment } from "../../../../../api/backend/backend-api"
import Typography from "../../../../../ui/atoms/Typography"
import { ClockIcon, MarkerIcon } from "../../../../../ui/icons"

interface Props {
  calendar: CalendarEventDataFragment
}

const EventCalendarInfo = ({ calendar }: Props) => {
  return (
    <div>
      <Typography variant="h5">{calendar.definition.eventName}</Typography>
      <div className="my-8">
        <div className="my-4">
          <Typography className="mb-2" weight="bold" variant="body1">
            Durata:
          </Typography>
          <Typography
            variant="subtitle2"
            className="flex items-center"
            colorValue="rgba(26, 26, 26, 0.6)"
          >
            <ClockIcon
              style={{
                fontSize: 20,
              }}
            />
            <span className="ml-2">{`${calendar.definition.defaultEventDurationMin} minuti`}</span>
          </Typography>
        </div>

        {calendar.definition.locationName && (
          <div className="my-4">
            <Typography className="mb-2" weight="bold" variant="body1">
              Luogo:
            </Typography>
            <Typography
              variant="subtitle2"
              className="flex items-center"
              colorValue="rgba(26, 26, 26, 0.6)"
            >
              <MarkerIcon
                style={{
                  fontSize: 20,
                }}
              />
              <span className="ml-2">{calendar.definition.locationName}</span>
            </Typography>
          </div>
        )}
      </div>
      <Typography variant="subtitle2" weight="normal" className="my-2">
        {calendar.definition.eventDescription}
      </Typography>
    </div>
  )
}

export default EventCalendarInfo
